import { Modal } from "antd"
import { useTranslation } from "react-i18next"
import PrimaryButton from "../button/PrimaryButton"
import SecondaryButton from "../button/SecondaryButton"
import style from "./Modal.module.css";

const ModalStartEndTrip = (props)=>{
  const {t} = useTranslation()
return(
  <>
  {/* <ModalFailedDelet
        show={failedModalOpen}
        onOk={() => setFailedModalOpen(false)}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be deleted"
        description="Because Driver already made an order trip"
      />

      <ModalSuccessDelete
        show={successModalOpen}
        action={() => actionOk()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been deleted"
      /> */}
      <Modal
        visible={props.visible}
        closable={false}
        centered={true}
        width={props.isPaid ? props.widthPaid :"464px"}
        footer={null}
      >
        {props.isPaid ? 
        <div className={style.ModalTitle}>{props.title2}</div> : 
        
        <div className={style.ModalTitle}>{props.title}</div>}
        <div className={style.ModalSubTitle}  >
          <div>{props.message}</div>
          {/* <br /> */}
          <div className="font-semibold text-black-300">{props.message2}</div>
          {/* {props.id} - {props.title}? */}
        </div>

        <div
          style={{
            justifyItems: "center",
            margin: 0,
            padding: 0,
            display: "flex",
          }}
        >
          <div className="mr-8 ml-9">
            <SecondaryButton
            // styles={props.styles}
            //   text={t("Yes, ")+props.title}
            //   action={() => props.onClick()}
            text={t("USER_DETAIL:CANCEL")}
            action={() => props.action()}
            />
          </div>

          <PrimaryButton
            // text={t("USER_DETAIL:CANCEL")}
            // action={() => props.action()}
            text={"Yes, "+props.titles ? props.titles :props.title}
            action={() => props.onClick()}
          />
        </div>
      </Modal>
  </>
)
}

export default ModalStartEndTrip